export default __webpack_public_path__ + "static/media/gallery-wip-pommel_00.6d3e14f2.jpg";